import { gql, useLazyQuery } from "@apollo/client";
import {
  ListGoodDetailQuery,
  ListGoodDetailQueryVariables,
} from "../generated/graphql";
import { CouponScopeEnum, CouponStatusEnum } from "../constants/enum";

const LIST_COUPON_QUERY = gql`
  query listCoupon($input: ListCouponInput!) {
    listCoupon(input: $input) {
      ok
      err
      coupons {
        id
        name
        code
        status
        scope
        linkService {
          id
          name
        }
        corporation {
          id
          name
        }
        discountPrice
        usageLimit
        userUsageLimit
        validFrom
        validUntil
        createdAt
      }
      totalPages
      totalResults
    }
  }
`;

export interface ListCouponInput {
  page: number;
  search: string;
  start?: string;
  end?: string;
}

export interface ListCouponQueryVariables {
  input: ListCouponInput;
}

export interface ListCouponQuery {
  listCoupon: {
    ok: boolean;
    err: string;
    coupons: {
      id: number;
      name: string;
      code: string;
      status: CouponStatusEnum;
      scope: CouponScopeEnum;
      linkService: {
        id: number;
        name: string;
      };
      corporation: {
        id: number;
        name: string;
      };
      discountPrice: number;
      usageLimit: number;
      userUsageLimit: number;
      validFrom: string;
      validUntil: string;
      createdAt: string;
    }[];
    totalPages: number;
    totalResults: number;
  };
}

export const useListCoupon = (
  onCompleted?: (data: ListCouponQuery) => void
) => {
  return useLazyQuery<ListCouponQuery, ListCouponQueryVariables>(
    LIST_COUPON_QUERY,
    {
      onCompleted,
      fetchPolicy: "network-only",
    }
  );
};
